module.exports = __webpack_public_path__ + "img/T2C_rc_6.af316a38.png";